import styled from "styled-components"
import DataTable_s from "components/table/data-table-styles"
import { Colors } from 'styles/app-styles'

export const FolderUW_s = styled.div`
  > div:first-child {
    background: ${Colors.inputFocus};
    border: 1px solid ${Colors.towerGrey};
    display: flex;
    flex-direction: column;
    margin: -20px 15px 15px 15px;
    padding: 15px;
    > div:first-child {
      display: flex;
      > div {
        display: flex;
        flex-direction: column;
        margin-right: 15px;
      }
      > div:last-child {
        margin-top: 12px;
        position: absolute;
        right: 15px;
      }
    }
    > div:last-child {
      border-top: 1px solid ${Colors.towerGrey};
      margin: 20px 0 0 0;
      padding-top: 15px;
      * { margin-right: 15px; }
    }
  }
  > div:last-child {
    padding: 0 15px;
    label {
      color: ${Colors.blackPearl};
      font-size: 16px;
      font-weight: 400;
      margin: 0 0 15px 15px;
      text-transform: uppercase;
    }
    ${DataTable_s}{
      margin-top: 15px;

      tbody.p-datatable-tbody > tr > td {
        padding-left: 5px;
      }

      svg .r-svg {
        fill: ${Colors.blackPearl};
      }

      div.p-paginator {
        position: absolute;
      }
    }
  }
`
